<template>
  <b-modal :id="modalId" hide-footer title="Zmień recepturę kuwertury">
    <ValidationObserver v-slot="{ invalid }">
      <form>
        <div class="row">
          <div class="col">
            <validation-provider rules="required" v-slot="{ errors }">
              <small><b>Receptura</b></small>
              <v-select
                :options="recipes"
                label="name"
                v-model="selectedRecipe"
                :reduce="(x) => x.id"
              ></v-select>
              <b-alert v-if="errors.length > 0" show variant="danger">
                {{ errors[0] }}
              </b-alert>
            </validation-provider>
          </div>
        </div>

        <div class="div-form-buttons-area mt-3">
          <b-button variant="primary" :disabled="invalid || !selectedRecipe" @click="changeRecipe">
            Zmień recepturę
          </b-button>
          <b-button variant="warning" @click="closeModal">
            Anuluj
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import recipesMixin from '../../../mixins/recipes';
import toastrMixin from '../../../mixins/toastr';
import CouvertureService from '../../../services/couverture.service';

export default {
  name: "ChangeCouvertureRecipeModal",
  mixins: [recipesMixin, toastrMixin],
  components: {
    ValidationObserver
  },
  props: {
    mill: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      recipes: [],
      selectedRecipe: null
    };
  },
  computed: {
    modalId() {
      return `changeRecipeModal-${this.mill.millId}`;
    }
  },
  methods: {
    openModal() {
      this.loadRecipes();
      this.$bvModal.show(this.modalId);
    },
    closeModal() {
      this.selectedRecipe = null;
      this.$bvModal.hide(this.modalId);
    },
    loadRecipes() {
      const that = this;
      this.getRecipes()
        .then((res) => {
          that.recipes = res.data;
          // Pre-select current recipe - use $nextTick to ensure recipes are rendered
          that.$nextTick(() => {
            const recipeId = that.mill.recipeId || that.mill.RecipeId;
            that.selectedRecipe = recipeId;
          });
        })
        .catch((err) => {
          console.log(err);
          that.DisplayError('Błąd', 'Nie udało się pobrać receptur');
        });
    },
    changeRecipe() {
      const that = this;
      if (!this.selectedRecipe) {
        this.DisplayError('Błąd', 'Wybierz recepturę');
        return;
      }

      CouvertureService.changeCouvertureRecipe(this.mill.couvertureId, this.selectedRecipe)
        .then(() => {
          that.DisplaySuccess('Sukces', 'Receptura została zmieniona');
          that.closeModal();
          that.$emit('RecipeChanged');
        })
        .catch((err) => {
          console.log(err);
          that.DisplayError('Błąd', 'Nie udało się zmienić receptury');
        });
    }
  },
};
</script>

<style scoped>
.div-form-buttons-area {
  display: flex;
  gap: 10px;
}
</style>
